import { render } from "./PrivacyAgreement.vue?vue&type=template&id=656d9bd0&scoped=true"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js"

import "./PrivacyAgreement.vue?vue&type=style&index=0&id=656d9bd0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656d9bd0"]])

export default __exports__